// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class Integration {
  readonly id: string;
  readonly tenantId: string;
  readonly name: string;
  readonly integrationType: Enums.IntegrationType;
  readonly config: { [key: string]: any };
  readonly externalIdentifier: string;
  readonly isActive: boolean;
  readonly createdAt: DateTime;
  readonly createdBy: string;
  readonly updatedAt: DateTime;
  readonly updatedBy: string;
  readonly archivedAt: DateTime | null;
  readonly archivedBy: string | null;
  readonly isArchived: boolean;
  readonly exportQuotes: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.tenantId = data.tenantId === undefined ? NIL_UUID : data.tenantId;
    this.name = data.name === undefined ? '' : data.name;
    this.integrationType =
      data.integrationType === undefined ? Enums.IntegrationType.Series : data.integrationType;
    this.config = data.config === undefined ? {} : data.config;
    this.externalIdentifier = data.externalIdentifier === undefined ? '' : data.externalIdentifier;
    this.isActive = data.isActive === undefined ? false : data.isActive;
    this.createdAt = DateHelpers.ParseServerDate(data.createdAt);
    this.createdBy = data.createdBy === undefined ? NIL_UUID : data.createdBy;
    this.updatedAt = DateHelpers.ParseServerDate(data.updatedAt);
    this.updatedBy = data.updatedBy === undefined ? NIL_UUID : data.updatedBy;
    this.archivedAt = DateHelpers.ParseServerNullableDate(data.archivedAt);
    this.archivedBy = data.archivedBy === undefined ? null : data.archivedBy;
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
    this.exportQuotes = data.exportQuotes === undefined ? false : data.exportQuotes;
  }

  static zero(): Integration {
    const zeroValues: ExcludeMethodsDeep<Integration> = {
      id: NIL_UUID,
      tenantId: NIL_UUID,
      name: '',
      integrationType: Enums.IntegrationType.Series,
      config: {},
      externalIdentifier: '',
      isActive: false,
      createdAt: DateHelpers.ParseServerDate(DateHelpers.ZERO_DATE_STRING),
      createdBy: NIL_UUID,
      updatedAt: DateHelpers.ParseServerDate(DateHelpers.ZERO_DATE_STRING),
      updatedBy: NIL_UUID,
      archivedAt: null,
      archivedBy: null,
      isArchived: false,
      exportQuotes: false,
    };
    return new Integration(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type IntegrationWireFormat = {
  id: string;
  tenantId: string;
  name: string;
  integrationType: string;
  config: { [key: string]: any };
  externalIdentifier: string;
  isActive: boolean;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
  archivedAt: string | null;
  archivedBy: string | null;
  isArchived: boolean;
  exportQuotes: boolean;
};

type NewIntegrationProps = PartialDeep<Integration, { recurseIntoArrays: true }>;
export const NewIntegration: (props: NewIntegrationProps) => Integration = (props) =>
  new Integration(props);

type NewIntegrationFromWireFormatProps = PartialDeep<
  IntegrationWireFormat,
  { recurseIntoArrays: true }
>;
export const NewIntegrationFromWireFormat: (
  props: NewIntegrationFromWireFormatProps,
) => Integration = (props) => new Integration(props);
